module.exports = __webpack_public_path__ + "static/media/nas.bc69feaf.png";